import React from 'react'

function PatientInvalidInfo() {
  return (
   <>
    <table className="table table-striped gy-7">
      <thead>
        <tr className='fw-bolder fs-6 text-gray-800'>
          <th>Type</th>
          <th>Details</th>
          <th>Created</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Email</td>
          <td>"yash@eyeconx.net</td>
           <td>2024-04-13T18:46:00</td>
        </tr>
      </tbody>
    </table>
   </>
  )
}

export default PatientInvalidInfo